import PageHeading from "./PageHeading";
import { Parallax } from "react-scroll-parallax";
import { useContext } from "react";
import "../../../css/azienda.css";
import useFetch from "../../../hooks/useFetch";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import LanguageContext from "../../../context/language-context";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";

// Intersection Observer options
export default function ContractInner() {
  const { slug } = useParams(); // Get the slug from the URL params

  const languageCtx = useContext(LanguageContext); // Get the current language context
  const { loading, error, data } = useFetch(
    `https://spagnoladmin.spagnolcompany.it/api/contracts?locale=${languageCtx.languageData}&populate[0]=Banner_Image&poopulate[1]=Contract_Item&populate[2]=Contract_Item.Inner_Image&poopulate[3]=Contract_Item.Inner_details&populate[4]=Contract_Item.Inner_details.Medium_Image&populate[5]=Contract_Item.Inner_details.Small_Image&populate[6]=Contract_Item.Front_Image&populate[7]=Contract_Item.Inner_details.Big_Image`
  );

  if (loading) {
    return <p>Loading...</p>; // Display loading message while data is being fetched
  }

  const { data: details, meta } = data;
  const selectedProducts = details[0].attributes.Contract_Item.find(
    (item) => item.Title.toLowerCase().trim() === slug
  );
  return (
    <div className="mg-3">
      <PageHeading img={selectedProducts?.Inner_Image.data.attributes.url} />
      <div className="mission-text" data-scroll-section>
        <Parallax speed={6}>
          <BlocksRenderer
            content={selectedProducts.Inner_Title}
            blocks={{
              paragraph: ({ children }) => (
                <p className="mt-4 text-base lg:text-xl">{children}</p>
              ),
              heading: ({ children, level }) => {
                const Tag = `h${level}`;
                return (
                  <Tag className="mt-4 font-bold text-base lg:text-2xl">
                    {children}
                  </Tag>
                );
              },
              list: ({ children, format }) =>
                format === "unordered" ? (
                  <ul className="list-disc list-inside ml-6 mt-4">
                    {children}
                  </ul>
                ) : (
                  <ol className="list-decimal list-inside ml-6 mt-4">
                    {children}
                  </ol>
                ),
              quote: ({ children }) => (
                <blockquote className="border-l-4 border-gray-300 pl-4 font-extrabold text-2xl text-black mt-4 w-[80%]">
                  {children}
                </blockquote>
              ),
              link: ({ children, url }) => (
                <Link to={url} className="text-footer underline">
                  {children}
                </Link>
              ),
            }}
          />
        </Parallax>
      </div>
      {selectedProducts.Inner_details.map((item, index) => (
        <Parallax speed={6} key={index}>
          <div className="brand-image">
            <div className="first-section">
              <div
                className={`section-inner contracts ${
                  (index + 1) % 2 === 0 ? "row-reverse" : ""
                }`}
              >
                <div className="left-text contract curve">
                  <Parallax speed={6}>
                    <div className="hovereffect">
                      <a className="test curve">
                        <img
                          src={`https://spagnoladmin.spagnolcompany.it${item.Small_Image.data.attributes.url}`}
                        />
                      </a>
                    </div>
                    <p>{item.Text}</p>
                    <br />
                  </Parallax>
                </div>
                <div className="right-text curve contract">
                  <Parallax speed={6}>
                    <div className="hovereffect">
                      <a className="test curve">
                        <img
                          src={`https://spagnoladmin.spagnolcompany.it${item.Big_Image.data.attributes.url}`}
                        />
                      </a>
                    </div>
                  </Parallax>
                </div>
              </div>
            </div>
            <section className="middle-image brand" data-scroll-section>
              <img
                key={index}
                src={`https://spagnoladmin.spagnolcompany.it${item.Medium_Image.data.attributes.url}`}
              />
            </section>
          </div>
        </Parallax>
      ))}
    </div>
  );
}
